import { render, staticRenderFns } from "./LabGasLaws.vue?vue&type=template&id=7b657c82&"
import script from "./LabGasLaws.vue?vue&type=script&lang=js&"
export * from "./LabGasLaws.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports